/**
 * ThemedToastContainer — wrapper над react-toastify ToastContainer,
 * берущий цвета/радиус из AntD theme tokens. Match с остальным UI.
 *
 * Зачем: дефолтные стили react-toastify выглядят generic (белый/чёрный fill,
 * yellow на warn, дефолтный border-radius). В dark-теме особенно выделяются.
 *
 * Не вмешиваемся в react-toastify lifecycle — только css-vars override через
 * style prop у самого ToastContainer + per-toast стили через toastClassName.
 */
import React from 'react';
import { ToastContainer, ToastContainerProps, Theme } from 'react-toastify';
import { theme } from 'antd';
import { useThemeStore } from '../stores/themeStore';

export type ThemedToastContainerProps = Omit<ToastContainerProps, 'theme'>;

export function ThemedToastContainer(props: ThemedToastContainerProps): React.ReactElement {
  const { token } = theme.useToken();
  const mode = useThemeStore((s) => s.mode);
  const toastTheme: Theme = mode === 'dark' ? 'dark' : 'light';

  return (
    <ToastContainer
      {...props}
      theme={toastTheme}
      toastStyle={{
        background: token.colorBgElevated,
        color: token.colorText,
        borderRadius: token.borderRadiusLG,
        border: `1px solid ${token.colorBorder}`,
        fontFamily: token.fontFamily,
      }}
    />
  );
}

export default ThemedToastContainer;
